/**
 * @generated SignedSource<<e69bae71a5d5b94e2797eee096b98e95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventActorAvatarItemBadge$data = {
  readonly avatarUrl: string;
  readonly login: string;
  readonly " $fragmentType": "EventActorAvatarItemBadge";
};
export type EventActorAvatarItemBadge$key = {
  readonly " $data"?: EventActorAvatarItemBadge$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventActorAvatarItemBadge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventActorAvatarItemBadge",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": 64
        }
      ],
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": "avatarUrl(size:64)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "login",
      "storageKey": null
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};

(node as any).hash = "805f15e64b689fcda82b00e700c41806";

export default node;
